import axios from 'axios';

// ==============================|| AXIOS INSTANCE ||============================== //

const axiosServices = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL || 'http://127.0.0.1:8000/api'
});

// ==============================|| AXIOS - INTERCEPTOR ||============================== //

axiosServices.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('serviceToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized (logout or redirect)
      localStorage.removeItem('serviceToken');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong with network');
  }
);

export default axiosServices;

export const fetcher = (url) => axiosServices.get(url).then((res) => res.data);
